/* eslint-disable max-len */
/* eslint-disable import/no-duplicates */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import { classNames } from 'shared/lib/classNames/classNames';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import { BackgroundHandler } from 'shared/ui/BackgroundHandler/BackgroundHandler';
import { useApi } from 'app/api/APIProvider';
import { FormTypes, Forms } from 'entities/Forms/Forms';
import { useBackgrounds } from 'shared/lib/hooks/useBackgrounds/useBackgrounds';
import { LazyBackground } from 'shared/ui/LazyBackground';
import { PreloadImg } from 'shared/ui/PreloadImg';
import cls from './AuthPage.module.scss';
// import { PreloadImg } from 'shared/ui/PreloadImg';

// import background1700 from 'shared/assets/img/auth/town-1700.png';
// import background1200 from 'shared/assets/img/auth/town-1200.png';
// import background1024 from 'shared/assets/img/auth/town-1024.png';
// import background768 from 'shared/assets/img/auth/town-768.png';
// import background370 from 'shared/assets/img/auth/town-768.png';

export const AuthPage = () => {
    const [isUserAuth, setIsUserAuth] = useState('SignIn');
    const [isSignedUp, setIsSignedUp] = useState(true);
    const navigate = useNavigate();
    const api = useApi();
    const townAuth = useBackgrounds('townAuth');
    const room = useBackgrounds('room');

    useEffect(() => {
        // if (api.LoginState === 'email_verification_needed') setIsUserAuth('Email');
        // else if (api.LoginState === 'logged_in') navigate('/');
        if (api.LoginState === 'logged_in') navigate('/');
    }, []);

    const updateUserAuthStatus = (value: string) => {
        setIsUserAuth(value);
    };

    const mothodForSmsRequest = (value: boolean) => {
        setIsSignedUp(value);
    };

    // const images = {
    //     1700: `url(${background1700})`,
    //     1200: `url(${background1200})`,
    //     1024: `url(${background1024})`,
    //     768: `url(${background768})`,
    //     370: `url(${background370})`,
    // };

    return (
        <div className={cls.page}>
            {/* <BackgroundHandler images={images} /> */}
            <LazyBackground
                tnImg={townAuth.tnBackground}
                originalImg={townAuth.background}
                overlay="linear-gradient(136deg, rgba(15, 167, 223, 0.50) 0%, rgba(61, 187, 110, 0.50) 57.29%, rgba(142, 245, 11, 0.50) 97.92%)"
            >
                <div className={classNames(cls.form, { [cls.active]: isUserAuth === 'SignUp' || isUserAuth === 'SignIn' })}>
                    <Forms type={FormTypes.phone} statusHandler={updateUserAuthStatus} step={isUserAuth} mothodForSmsRequest={mothodForSmsRequest}/>
                </div>
                <div className={classNames(cls.form, { [cls.active]: isUserAuth === 'Sms' })}>
                    <Forms type={FormTypes.sms} statusHandler={updateUserAuthStatus} step={isUserAuth} isSignedUp={isSignedUp}/>
                </div>
                {/* <div className={classNames(cls.form, { [cls.active]: isUserAuth === 'SignIn' })}>
                    <Forms type={FormTypes.signIn} statusHandler={updateUserAuthStatus} />
                </div>
                <div className={classNames(cls.form, { [cls.active]: isUserAuth === 'SignUp' })}>
                    <Forms type={FormTypes.signUp} statusHandler={updateUserAuthStatus} />
                </div> */}
                {/* <div className={classNames(cls.form, { [cls.active]: isUserAuth === 'ForgotPass' })}>
                    <Forms type={FormTypes.recovery} statusHandler={updateUserAuthStatus} />
                </div> */}
                {/* <div className={classNames(cls.form, { [cls.active]: isUserAuth === 'Email' })}>
                    <EmailVerification />
                </div> */}
            </LazyBackground>
            <PreloadImg images={[room.background]} />
        </div>
    );
};
